import React from "react";

const Footer = () => {
  return <div class="footer">Made with 💛 by Shreyas</div>;
};

export default Footer;
